import Head from 'next/head'
import Script from 'next/script'
import {useRouter} from '_app/hooks/useRouter'

const LoadEasyPack = () => {
    const {locale} = useRouter()
    const isProduction = process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production'
    const baseUrl = isProduction
        ? 'https://geowidget.inpost.pl'
        : 'https://sandbox-easy-geowidget-sdk.easypack24.net'
    return (
        <>
            {
                locale === 'pl' && (
                    <>
                        <Head>
                            <link
                                rel="stylesheet"
                                href={`${baseUrl}/inpost-geowidget.css`}
                            />
                        </Head>
                        <Script
                            id="inpost"
                            strategy="afterInteractive"
                            src={`${baseUrl}/inpost-geowidget.js`}
                        />
                    </>
                )
            }
        </>
    )
}

export default LoadEasyPack